import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'
import { useSelector } from 'react-redux'

import { LOGIN, PAYMENT_PROCESSING, HOME_PSIC } from 'settings/_routesSettings'

import { isSimpleSignUpEnabled } from 'utils/isSimpleSignUpEnabled'

import { history } from 'routers/AppRouter'

import NotificationStep from 'components/NotificationStep'
import { Column, Container } from 'components'
import Logo from 'components/Logo'
import Row from 'components/Row'

const FeedbackSuccess = () => {
  const order = useSelector(state => state.orders.order)
  const register = useSelector(state => state.register)
  const groupPlans = useSelector(state => state.plans.groupPlans)
  
  const continueButton = order && order.product_group_code && order.schedules && order.schedules.length > 0
  
  const hasSimpleSignUp = isSimpleSignUpEnabled(groupPlans.code)

  function handleButtonClick() {
    if (order && order.product_group_code && order.schedules && order.schedules.length > 0) {
      history.push(`${LOGIN}?redirectTo=${PAYMENT_PROCESSING}`)
    } else if (hasSimpleSignUp) {
      history.push(`${LOGIN}`)
    } else if (!groupPlans.use_atena && (groupPlans.code !== 'GPL01001')) {
      history.push({
        pathname: `${HOME_PSIC}`,
        state: { groupPlans, userFirstName: register.firstName}
      })
    } else {
      history.push(`${LOGIN}?redirectTo=${HOME_PSIC}`)
    }
  }

  function renderSuccessFeedback() {
    if (hasSimpleSignUp) {
      return (
        <>
          <Row margin='15px 0 10px 0' justify='center'>
            <Typography
              center
              variant='header3'
            >
              Sua conta foi criada com sucesso! 
            </Typography>
          </Row>
          <Row margin='0 0 20px 0' justify='center'>
            <Typography
              center
              variant='content2'
            >
              Utilize o botão abaixo para fazer login e <br /> entrar em sua conta da Telavita.
            </Typography>
          </Row>
        </>
      )
    }

    return (
      <>
        <Row margin='15px 0 0' justify='center'>
          <Typography
            center
            variant='header3'
          >
            Conta criada com sucesso! 
          </Typography>
        </Row>
        <Row margin='10px 0 15px' justify='center'>
          <Typography
            center
            variant='content2'
            inlineStyles={{ maxWidth: '284px' }}
          >
            Agora é só buscar um profissional e agendar uma consulta. 
          </Typography>
        </Row>
      </>
    )
  }

  return (
    <Container>
      <Row justify='center' className='Register__Header'>
        <Column align='center' justify='center' colWidth={4}>
          <Column style={{ textAlign: 'center' }}>
            <Logo
              fill='#1f35b5'
              onClickLogo={() => (window.location.href = process.env.REACT_APP_INSTITUTIONAL_URL)}
            />
          </Column>
        </Column>
      </Row>
      <Row margin='30px 0 0 0' justify='center'>
        <NotificationStep
          btnText={
            hasSimpleSignUp ? 'ENTRAR' : continueButton ? 'CONTINUAR' : 'CONHECER PROFISSIONAIS'
          }
          iconColor='#4ac326'
          iconName='Check'
          hasButton={true}
          onSuccessClick={handleButtonClick}
          mainText={renderSuccessFeedback()}
        />
      </Row>
    </Container>
  )
}

export default FeedbackSuccess